<template>
  <el-dialog
      :visible.sync="visible"
      :before-close="handleClose"
      :title="title"
      width="750px">
    <el-button slot="footer" type="primary" icon="el-icon-s-platform" @click="upsert">
      儲存
    </el-button>
    <el-form label-width="80px" :model="company" :rules="rules" ref="ruleForm">
      <el-form-item label="統一編號" prop="companyId">
        <div class="filter-wrapper">
          <el-input v-model="company.companyId"/>
          <el-button @click.stop="findByCompanyId()" type="primary"
            size="small" icon="el-icon-plus">
            查詢
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="公司代碼" prop="companyNo">
        <el-input v-model="company.companyNo"/>
      </el-form-item>
      <el-form-item label="公司名稱" prop="companyName">
        <el-input v-model="company.companyName"/>
      </el-form-item>
      <el-form-item label="部門代碼" prop="departmentNo">
        <el-select class="w-full"
        v-if="!dept" 
        v-model="company.departmentNo" allow-create clearable filterable 
        placeholder="請選擇"
        >
          <el-option v-for="item in depts" :key="item" :label="item" :value="item"/>
        </el-select>
        <el-input 
        v-else
        v-model="company.departmentNo"/>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {dialogVisible, dialogTitle, company, type, depts, add, update, dept, handleClose, findByCompanyId} from "./useCompany.js";

export default {
  name: "CrudCompany",
  setup() {

    return {visible: dialogVisible, title: dialogTitle, company, depts, type, add, update, dept, handleClose, findByCompanyId}
  },
  methods: {
    upsert() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.type === "add" ? this.add(this.company) : this.update(this.company);
        } else {
          console.warn("欄位驗證 failed on submit!!");
          return false;
        }
      });
    },
  },
  data() {
    return {
      rules: {
        companyName: [
          {required: true, message: "公司名稱為必填欄位", trigger: "change"},
        ],
        companyId: [
          {required: true, message: "統一編號為必填欄位", trigger: "change"},
        ],
        companyNo: [
          {required: true, message: "公司代碼為必填欄位", trigger: "change"},
        ],
        departmentNo: [
          {required: true, message: "部門代碼為必填欄位", trigger: "change"},
        ],
      }
    };
  },
};
</script>

<style scoped>
.filter-wrapper {
  display: flex;
  align-items: center;
}

</style>
